import { MasterDataMapper } from '@/data/persistences/mappers/MasterDataMapper'
import { MasterDataRepositoryInterface } from '@/data/persistences/repositories/contracts/MasterDataRepositoryInterface'
import { Reasons } from '@/domain/entities/MasterData'
import { Endpoints } from '../../misc'
import ApiService from '../../services/ApiService'

export class MasterDataApiRepository implements MasterDataRepositoryInterface {
  private service: ApiService
  private mapper: MasterDataMapper

  constructor(service: ApiService, mapper: MasterDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getReasons(): Promise<Reasons> {
    const resp = await this.service.invoke(
      'GET',
      Endpoints.Route.MASTERDATA_REASON
    )

    return this.mapper.convertResponseListReasonFromApi(resp)
  }
}
